import { Dropdown } from "react-bootstrap";
import styled from "styled-components";
import { useState } from "react";
import useGetCensusParams from "./GetCensusParams";
import { CensusCategory } from "../../../../../types/Census/CensusCategory";
import CensusUrlKeys from "../../../../../constant/CensusUrlKeys";
import StyledToggle from "../../../../boundarySelection/ViewTools/StyledToggle";

const CensusDropdown = styled(Dropdown)`
  width: 650px;
`;

const CensusDropdownMenu = styled(Dropdown.Menu)`
  font-size: 12px;
  max-height: 500px;
  width: 100%;
  overflow-y: auto;
`;

const SearchInput = styled.input`
  border: none;
  background: transparent;
  outline: none;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: inherit;
`;

interface CategoryDropdownProps {
  categories: CensusCategory[];
  loading: boolean;
  showValidationError: boolean;
}

const CategoryDropdown = ({
  categories,
  loading,
  showValidationError,
}: CategoryDropdownProps) => {
  const { categoryId, handleSelect } = useGetCensusParams();
  const [searchText, setSearchText] = useState("");
  const [show, setShow] = useState(false);

  const handleChange = (selectedCategory: string | null) => {
    handleSelect(CensusUrlKeys.CATEGORY, Number(selectedCategory));
    setSearchText("");
    setShow(false);
  };

  const handleToggle = (nextShow: boolean) => {
    setShow(nextShow);
    if (!nextShow) setSearchText("");
  };

  const isInvalid = showValidationError && categoryId === null;

  const selectedCategoryName =
    categories
      .find((c) => c.categoryId === categoryId)
      ?.categoryName.replace(/\(.*?\)/g, "")
      .trim() ?? "";

  const inputValue = show ? searchText : selectedCategoryName;

  const filteredCategories =
    searchText ?
      categories.filter((c) =>
        c.categoryName.toLowerCase().includes(searchText.toLowerCase()),
      )
    : categories;

  return (
    <CensusDropdown show={show} onSelect={handleChange} onToggle={handleToggle}>
      <StyledToggle
        disabled={categories.length === 0 || loading}
        style={{ width: "285px" }}
        $isInvalid={isInvalid}
        className="view-tools-dropdown fs-6 text-white"
        size="lg"
      >
        <SearchInput
          id="census-search"
          placeholder={loading ? "Loading..." : "Search Categories...."}
          value={inputValue}
          title={selectedCategoryName || undefined}
          disabled={categories.length === 0 || loading}
          onChange={(e) => {
            setSearchText(e.target.value);
            setShow(true);
          }}
          onClick={(e) => {
            e.stopPropagation();
            setShow(true);
          }}
        />
      </StyledToggle>

      <CensusDropdownMenu>
        {filteredCategories.map((y) => (
          <Dropdown.Item
            key={y.categoryId}
            eventKey={String(y.categoryId)}
            active={y.categoryId === categoryId}
            disabled={!y.columns.some((col) => col.haveData)}
          >
            {y.categoryName}
          </Dropdown.Item>
        ))}
      </CensusDropdownMenu>
    </CensusDropdown>
  );
};

export default CategoryDropdown;
